var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',[_c('avue-crud',{ref:"crud",attrs:{"option":_vm.option,"data":_vm.list,"page":_vm.page},on:{"row-save":_vm.rowSave,"row-del":_vm.rowDel,"row-update":_vm.rowUpdate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }